// Bank-account helpers shared by Refund Mgmt and the payment sheet.
// Mirrors backend/invoices/airwallex.py (LOCAL_ROUTING / looks_like_iban).

// Two letters, two digits, then 11+ alphanumerics - an IBAN shape.
export const looksLikeIban = (s) => {
  const v = String(s || '').replace(/\s+/g, '').toUpperCase();
  return v.length >= 15 && /^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(v);
};

// Non-IBAN countries and the routing code(s) Airwallex needs for a local account.
export const LOCAL_ROUTING = {
  AU: [{ label: 'BSB', digits: 6, placeholder: '062-000' }],
  GB: [{ label: 'Sort code', digits: 6, placeholder: '40-47-84' }],
  US: [{ label: 'Routing number (ABA)', digits: 9, placeholder: '021000021' }],
  CA: [{ label: 'Institution number', digits: 3, placeholder: '003' }, { label: 'Transit number', digits: 5, placeholder: '05032' }],
  HK: [{ label: 'Bank code', digits: 3, placeholder: '004' }, { label: 'Branch code', digits: 3, placeholder: '015' }],
  SG: [{ label: 'Bank code', digits: 0, placeholder: '7171' }, { label: 'Branch code', digits: 0, placeholder: '001' }],
  IN: [{ label: 'IFSC', digits: 11, placeholder: 'HDFC0000001' }],
  NZ: [],
  JP: [{ label: 'Bank code', digits: 4, placeholder: '0001' }, { label: 'Branch code', digits: 3, placeholder: '001' }],
  ZA: [{ label: 'Branch code', digits: 6, placeholder: '051001' }],
};

export const LOCAL_COUNTRIES = [
  ['AU', 'Australia'], ['GB', 'United Kingdom'], ['US', 'United States'], ['CA', 'Canada'], ['NZ', 'New Zealand'],
  ['HK', 'Hong Kong'], ['SG', 'Singapore'], ['JP', 'Japan'], ['IN', 'India'], ['ZA', 'South Africa'],
];
